import { Button, CircularProgress, Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  getFrontOAuthRedirectUri,
  parseOAuthCallbackState,
} from "../../utils/frontOAuth";

const FrontContactSyncModal = ({
  open,
  setOpen,
  code,
  onSuccess,
}) => {
  const [step, setStep] = useState(1);
  const [errorMsg, setErrorMsg] = useState(null);
  const navigate = useNavigate();

  const exchangeCode = async (organizationId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}front/contact-sync/oauth/exchange`,
        {
          code,
          redirect_uri: getFrontOAuthRedirectUri(),
          organization_id: organizationId,
        }
      );

      if (response.data?.updatedItem) {
        localStorage.setItem(
          "organization",
          JSON.stringify(response.data.updatedItem)
        );
      }

      setStep(2);
      onSuccess?.(response.data);

      setTimeout(() => {
        navigate("/dashboard/contacts", { replace: true });
        setOpen(false);
      }, 1500);
    } catch (error) {
      console.error(
        "Front contact sync OAuth exchange failed",
        error.response?.data || error.message || error
      );
      setErrorMsg(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to connect Front contact sync"
      );
      setStep(3);
    }
  };

  useEffect(() => {
    if (!code || !open) return;

    const queryParams = new URLSearchParams(window.location.search);
    const state = queryParams.get("state");
    const parsed = parseOAuthCallbackState(state);

    if (parsed?.provider === "front_contact_sync" && parsed.organizationId) {
      exchangeCode(parsed.organizationId);
      return;
    }

    const orgData = JSON.parse(localStorage.getItem("organization") || "{}");
    const orgId = orgData?.orgId?.S;
    if (orgId) {
      exchangeCode(orgId);
    } else {
      setErrorMsg("Organization not found. Please log in again.");
      setStep(3);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, open]);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      BackdropProps={{
        style: { backgroundColor: "rgb(144,150,160,0.8)" },
      }}
    >
      {step === 1 && (
        <div className="lg:px-8 px-4 py-14 text-center">
          <CircularProgress size={36} sx={{ color: "rgba(96,91,255,1)" }} />
          <div className="lg:text-[20px] text-[#030229] text-[15px] font-semibold mt-6">
            Connecting Front contact sync...
          </div>
          <div className="lg:text-[15px] text-[rgb(78,88,101)] text-[13px] mt-2">
            Securing your connection with Front.
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="lg:px-8 px-4 py-14 text-center">
          <div className="flex justify-center">
            <div className="bg-[#DCFCE7] rounded-full p-3 px-4 text-[23px]">🎉</div>
          </div>
          <div className="lg:text-[20px] text-[#030229] text-[15px] font-semibold mt-4">
            Front connected!
          </div>
          <div className="lg:text-[15px] text-[rgb(78,88,101)] text-[13px] mt-1 mb-6">
            Your contacts are importing in the background. You can stay on this
            page — we&apos;ll update the list as they arrive.
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="lg:px-8 px-4 py-14 text-center">
          <div className="lg:text-[20px] text-[#030229] text-[15px] font-semibold mt-4">
            Connection failed
          </div>
          <div className="lg:text-[15px] text-red-600 text-[13px] mt-2 mb-6">
            {errorMsg}
          </div>
          <Button
            sx={{
              textTransform: "none",
              bgcolor: "rgba(96,91,255,1)",
              color: "white",
              py: "6px",
              px: "30px",
              borderRadius: "7px",
              fontWeight: 600,
            }}
            onClick={() => {
              navigate("/dashboard/contacts", { replace: true });
              setOpen(false);
            }}
          >
            Close
          </Button>
        </div>
      )}
    </Dialog>
  );
};

export default FrontContactSyncModal;
